"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _table_component = require("./global_components/table_component");

var _table_component2 = _interopRequireDefault(_table_component);

var _date_formatter = require("common-utilities/src/date_formatter");

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _string_utility = require("common-utilities/src/string_utility");

var _string_utility2 = _interopRequireDefault(_string_utility);

var _collection_utility = require("common-utilities/src/collection_utility");

var _ramda = require("ramda");

var _functional_utility = require("common-utilities/src/functional_utility");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DailyPerformanceTable = function (_React$Component) {
  _inherits(DailyPerformanceTable, _React$Component);

  function DailyPerformanceTable() {
    _classCallCheck(this, DailyPerformanceTable);

    return _possibleConstructorReturn(this, (DailyPerformanceTable.__proto__ || Object.getPrototypeOf(DailyPerformanceTable)).apply(this, arguments));
  }

  _createClass(DailyPerformanceTable, [{
    key: "renderHeader",
    value: function renderHeader() {
      var asOfDate = this.props.fundShareclassPerformanceReturn.filter(function (item) {
        return !(0, _ramda.isNil)(item) && item.performanceReturnEffectiveDate !== null;
      })[0].performanceReturnEffectiveDate;
      var header = _string_utility2.default.renderFormattedLabel("Performance data", "pdp-daily-performance-table-header");
      var date = _date_formatter2.default.getEffectiveDateHeader("daily-performance-table", asOfDate, this.props.country, this.props.role, this.props.breakpoint);
      return _react2.default.createElement(
        "div",
        { className: "card-header border-bottom-2 border-light-grey padding-bottom-10 margin-bottom-15 print-hide", "data-testid": "performance-tabs" },
        _react2.default.createElement(
          "h3",
          { "data-testid": "daily-performance-table-header-label", className: "font-regular font-black-variant sub-header-3 print-hide" },
          header
        ),
        date
      );
    }
  }, {
    key: "generateTableHeaders",
    value: function generateTableHeaders() {
      var headers = [["oneDay", "1 DAY"], ["oneWeek", "1 WEEK"], ["MTD", "MTD"], ["oneMonth", "1 MONTH"], ["threeMonths", "3 MONTHS"], ["oneYear", "1 YEAR"], ["threeYears", "3 YEARS"], ["fiveYears", "5 YEARS"]];
      if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, "SHOW_10_YEARS_DAILY_PERFORMANCE")) {
        headers.push(["tenYears", "10 YEARS"]);
      } else {
        headers.push(["since-launch", "Since Inception"]);
      }
      var markup = [];
      markup.push(_react2.default.createElement("td", { className: "border-top-none", "data-testid": "daily-performance-table-header" }));
      headers.map(function (header) {
        return markup.push(_react2.default.createElement(
          "td",
          { className: "border-top-none tag text-right", "data-testid": "daily-performance-table-header" },
          _string_utility2.default.renderFormattedLabel(header[1], "pdp-performance-card-" + header[0])
        ));
      });
      return markup;
    }
  }, {
    key: "getPerformanceReturnData",
    value: function getPerformanceReturnData() {
      var _this2 = this;

      var fundShareclassPerformanceReturn = this.props.fundShareclassPerformanceReturn;
      var cols = ['1DY', '1WK', 'MTD', '1MT', '3MT', '1YR', '3YR', '5YR'];
      if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, "SHOW_10_YEARS_DAILY_PERFORMANCE")) {
        cols.push('10Y');
      } else {
        cols.push('INC');
      }
      var rowData = cols.map(function (col) {
        return _react2.default.createElement(
          "td",
          { className: "margin-top-5 print-font-size-13 text-right", "data-testid": 'daily-performance-table-data' },
          _this2.getCumulatieveNoLoadPercentage(fundShareclassPerformanceReturn, col)
        );
      });
      return _react2.default.createElement(
        "tr",
        { className: "padding-vertical-5 category row-divider" },
        _react2.default.createElement(
          "td",
          { className: "margin-top-5 print-font-size-13 text-left", "data-testid": 'daily-performance-table-data' },
          this.props.shortName
        ),
        rowData
      );
    }
  }, {
    key: "getCumulatieveNoLoadPercentage",
    value: function getCumulatieveNoLoadPercentage(fundShareclassPerformanceReturn, key) {
      var index = fundShareclassPerformanceReturn.map(function (o) {
        return o.returnPeriodIndicator;
      }).indexOf(key);
      if ((0, _ramda.isNil)(fundShareclassPerformanceReturn[index]) || (0, _ramda.isNil)(fundShareclassPerformanceReturn[index].cumulativeNoLoadPercentage)) {
        return '-';
      } else {
        return (fundShareclassPerformanceReturn[index].cumulativeNoLoadPercentage * 100).toFixed(2) + "%";
      }
    }
  }, {
    key: "renderTable",
    value: function renderTable() {
      return _react2.default.createElement(_table_component2.default, {
        printTitle: false,
        tableHeaders: this.generateTableHeaders(),
        tableHeadersStyle: { "textAlign": "right" },
        tableRows: this.getPerformanceReturnData(),
        breakpoint: this.props.breakpoint
      });
    }
  }, {
    key: "render",
    value: function render() {
      if ((0, _functional_utility.isNilOrEmpty)(this.props.fundShareclassPerformanceReturn)) {
        return null;
      }
      return _react2.default.createElement(
        "div",
        { id: "daily-performance-table", "data-testid": "daily-performance-data", className: "" + (this.props.breakpoint < 3 ? "margin-top-15" : "margin-top-30") },
        this.renderHeader(),
        this.renderTable()
      );
    }
  }]);

  return DailyPerformanceTable;
}(_react2.default.Component);

exports.default = DailyPerformanceTable;